module.exports = __webpack_public_path__ + "img/coal_select.41dcf9c1.png";